document.addEventListener("DOMContentLoaded", function () {
  if (typeof gsap === "undefined") {
    // eslint-disable-next-line no-console
    console.warn("GSAP not loaded");
    return;
  }

  const scrollTriggerAvailable =
    typeof ScrollTriggerUtils !== "undefined" && ScrollTriggerUtils.register();

  const headerSection = document.querySelector(".secondary-hero");
  if (!headerSection) {
    return;
  }

  const backgroundIcons = document.querySelectorAll(
    ".secondary-hero .hero-icons-bg .floating-icon"
  );
  const heroIconsBg = document.querySelector(".secondary-hero .hero-icons-bg");

  if (heroIconsBg && backgroundIcons.length > 0) {
    // Hero icons fade in
    gsap.to(heroIconsBg, {
      opacity: 1,
      duration: 1.5,
      ease: "power2.out",
      delay: 0.3,
    });

    if (scrollTriggerAvailable) {
      // Background icon parallax
      backgroundIcons.forEach((icon, index) => {
        const backgroundSpeeds = [0.1, 0.15, 0.12, 0.18, 0.13, 0.16];
        const speed = backgroundSpeeds[index % backgroundSpeeds.length];

        gsap.to(icon, {
          y: -200 * speed,
          ease: "none",
          scrollTrigger: {
            trigger: headerSection,
            start: "top top",
            end: "bottom top",
            scrub: 1,
            invalidateOnRefresh: true,
          },
        });
      });
    }
  }

  // Logo animation
  const logoItems = document.querySelectorAll(
    ".secondary-hero .logos-wrapper .logo-item"
  );
  if (logoItems.length > 0) {
    gsap.to(logoItems, {
      opacity: 1,
      y: 0,
      duration: 1.2,
      ease: "power2.out",
      stagger: 0.1,
      delay: 0,
    });
  }
});
